import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { TmaisBadgeFormSchema } from '../schemas/form.schema'

interface UseCreateTmaisBadgeProps {
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: AxiosError) => void
}

export const useCreateTmaisBadge = ({ onSuccess, onError }: UseCreateTmaisBadgeProps = {}) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createTmaisBadge'],
    mutationFn: async (form: TmaisBadgeFormSchema) => {
      const payload = {
        display_name: form.display_name.trim(),
        background_color: form.background_color.toUpperCase(),
        text_color: form.text_color.toUpperCase(),
        icon: form.icon instanceof File ? form.icon : undefined
      }

      return privateAxios.postForm('/tmais/badges', { badge: payload })
    },
    onSuccess,
    onError,
  })
}